import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Well } from 'react-bootstrap';
import PetitionForm from './PetitionForm';
import industryData from '../../data/industry';
import ch11TypeData from '../../data/ch11Type';
import './Petition.less';
import ScheduleVerifyToolbar from '../common/ScheduleVeriyToolbar';

class Petition extends Component {
  getPetitiondata = (schedule) => {
    const { data = {}, header = {} } = schedule;
    const naics = header.naics
      ? industryData.filter((industryValue) => industryValue.label.indexOf(header.naics) >= 0)[0].label
      : '';
    const ch11_type = header.ch11_type
      ? ch11TypeData.filter((ch11TypeValue) => ch11TypeValue.label === header.ch11_type)[0].label
      : '';
    return (
      <table id="petition">
        <tbody id="view-petitions">
          <tr>
            <td style={{ width: 225 }}>
              <label>
                <span className="label-petitioner">Principal place of business:</span>
              </label>
            </td>
            <td style={{ width: 225 }}>
              <label>
                <span className="label-petitioner">Location of principal assets:</span>
              </label>
            </td>
            <td />
          </tr>
          <tr>
            <td>
              <label>
                <span className="label">Street</span>
              </label>
              <br />
              {data.principal_place_of_business_street || ''}
            </td>
            <td>
              <label>
                <span className="label">Street</span>
              </label>
              <br />
              {data.location_place_of_business_street || ''}
            </td>
            <td />
          </tr>
          <tr>
            <td>
              <label>
                <span className="label">City</span>
              </label>
              <br />
              {data.principal_place_of_business_city || ''}
            </td>
            <td>
              <label>
                <span className="label">City</span>
              </label>
              <br />
              {data.location_place_of_business_city || ''}
            </td>
            <td />
          </tr>
          <tr>
            <td>
              <label>
                <span className="label">State</span>
              </label>
              <br />
              {data.principal_place_of_business_state || ''}
            </td>
            <td>
              <label>
                <span className="label">State</span>
              </label>
              <br />
              {data.location_place_of_business_state || ''}
            </td>
            <td />
          </tr>
          <tr>
            <td>
              <label>
                <span className="label">Zip Code</span>
              </label>
              <br />
              {data.principal_place_of_business_zip_code || ''}
            </td>
            <td>
              <label>
                <span className="label">Zip Code</span>
              </label>
              <br />
              {data.location_place_of_business_zip_code || ''}
            </td>
            <td />
          </tr>{' '}
          <tr>
            <td>
              <label>
                <span className="label">Country</span>
              </label>
              <br />
              {data.principal_place_of_business_country || ''}
            </td>
            <td>
              <label>
                <span className="label">Country</span>
              </label>
              <br />
              {data.location_place_of_business_country || ''}
            </td>
            <td />
          </tr>
          <tr>
            <td>
              <label>
                <span className="label">Describe debtor’s business</span>
              </label>
              <br />
              {data.describe_debtor_business || ''}
            </td>
            <td>
              <label>
                <span className="label">Authorized representative of debtor</span>
              </label>
              <br />
              {data.authorized_representative_of_debtor || ''}
            </td>
            <td>
              <label>
                <span className="label">Title</span>
              </label>
              <br />
              {data.title || ''}
            </td>
          </tr>
          <tr>
            <td>
              <label>
                <span className="label">Estimated number of creditors</span>
              </label>
              <br />
              {data.estimated_number_of_creditors || ''}
            </td>
            <td>
              <label>
                <span className="label">Estimated assets</span>
              </label>
              <br />
              {header.estimated_assets || ''}
            </td>
            <td>
              <label>
                <span className="label">Estimated liabilities</span>
              </label>
              <br />
              {header.estimated_liabilities || ''}
            </td>
          </tr>
          <tr>
            <td colSpan="2">
              <label>
                <span className="label">Website </span>
              </label>
              <br />
              {header.website || ''}
            </td>
            <td className="justify-alignment">
              <label>
                <span className="label">Chapter 11 Type</span>
              </label>
              <br />
              {ch11_type || ''}
            </td>
          </tr>
          <tr>
            <td colSpan="3">
              <label>
                <span className="label">Naics (4-digit code) </span>
              </label>
              <br />
              {naics || ''}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    const { schedule, editScheduleForm, can_see_details, canEdit, toggleScheduleForm, onSubmit, type } = this.props;
    const tableData = schedule || {};
    const noDataFoundMessage = schedule.data === null ? 'There is no Petition for this case.' : null;
    const statisticalSummaryMissing = schedule.header
      ? schedule.header.website === null &&
        schedule.header.estimated_assets === null &&
        schedule.header.ch11_type === null &&
        schedule.header.naics === null &&
        schedule.header.estimated_liabilities === null
      : null;
    const noDataFound = noDataFoundMessage || schedule.empty || null;

    if (statisticalSummaryMissing && noDataFound && !editScheduleForm) {
      return (
        <div id="ir-search-schedule-petition-results">
          <Well bsSize="small">{noDataFound}</Well>
          {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
          {canEdit && !editScheduleForm && (
            <div className="editable">
              <button className="btn btn-primary" onClick={toggleScheduleForm}>
                Edit
              </button>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className={type}>
        {can_see_details && (
          <React.Fragment>
            <div id="schedule-petition">
              <div id="ir-search-schedule-petition-results">
                {editScheduleForm ? (
                  <PetitionForm {...this.props} onSubmit={onSubmit} />
                ) : (
                  <React.Fragment>
                    {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
                    {this.getPetitiondata(tableData)}
                    {canEdit && (
                      <div className="editable">
                        <button className="btn btn-primary" onClick={toggleScheduleForm}>
                          Edit
                        </button>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

Petition.defaultProps = {
  type: 'petition',
};

Petition.propTypes = {
  schedule: PropTypes.any.isRequired,
  type: PropTypes.string,
  editScheduleForm: PropTypes.bool.isRequired,
  toggleScheduleForm: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  can_see_details: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default Petition;



// WEBPACK FOOTER //
// ./src/scheduleform/petition/Petition.jsx